import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/schedule/',
        component: () => import('@/pages/schedule/ScheduleIndex.vue'),
        props: true,
        name: 'schedule-index',
        children: [
            {
                name: 'time-periods-view-upcoming',
                path: '/schedule/time-periods/upcoming',
                component: () => import('@/components/time-periods/TimePeriodsView.vue'),
                props: true,
                meta: {
                    title: 'Schedules',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'time periods' },
                },
            },

            {
                name: 'time-periods-view-previous',
                path: '/schedule/time-periods/previous',
                component: () => import('@/components/time-periods/TimePeriodsView.vue'),
                props: true,
                meta: {
                    title: 'Schedules',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'time periods' },
                },
            },

            {
                name: 'activities-view-upcoming',
                path: '/schedule/activities/upcoming',
                component: () => import('@/components/activities/ActivitiesView.vue'),
                meta: {
                    title: 'Due Dates',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view an activity'),
                },
                props: true,
            },

            {
                name: 'activities-view-previous',
                path: '/schedule/activities/previous',
                component: () => import('@/components/activities/ActivitiesView.vue'),
                meta: {
                    title: 'Due Dates',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view an activity'),
                },
                props: true,
            },

            {
                name: 'meetings-view-upcoming',
                path: '/schedule/meetings/upcoming',
                component: () => import('@/components/meetings/MeetingsView.vue'),
                meta: {
                    title: 'Meetings',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view all meetings'),
                },
                props: true,
            },

            {
                name: 'meetings-view-previous',
                path: '/schedule/meetings/previous',
                component: () => import('@/components/meetings/MeetingsView.vue'),
                meta: {
                    title: 'Meetings',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view all meetings'),
                },
                props: true,
            },

            {
                name: 'term-schedule-overview',
                path: '/schedule/term-schedule-overview',
                component: () => import('@/components/term-schedule/TermScheduleOverview.vue'),
                meta: {
                    title: 'Term Schedule Overview',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view all meetings'),
                },
                props: true,
            },
        ],
    },
];
